import * as API from '.'

let url = 'api/journalData/';

export default {
    delJournalData: params => {
        return API.POST( url + 'delJournalData', params)
    },
    getJournalIssueList: params => {
        return API.POST( url + 'getJournalIssueList', params)
    },
    getIssueInfoList: params => {
        return API.POST( url + 'getIssueInfoList', params)
    },
    uploadFile: params => {
        return API.UPLOAD_POST( url + 'fileUpload', params)
    },
    passAudit: params => {
        return API.POST( url + 'passAudit', params)
    },
    rejectAudit: params => {
        return API.POST( url + 'rejectAudit', params)
    },
    getProcessDetail: params => {
        return API.POST( url + 'getProcessDetail', params)
    },
    retryPub: params => {
        return API.POST( url + 'retryPub', params)
    },
    getErrorDataByIssueList: params => {
        return API.POST( url + 'getErrorDataByIssueList', params)
    },
    getProcessDataInfoByPrimaryId: params => {
        return API.POST( url + 'getProcessDataInfoByPrimaryId', params)
    },
    addSupplementIssue: params => {
        return API.POST( url + 'addSupplementIssue', params)
    },
    deleteJournalData: params => {
        return API.POST( url + 'deleteJournalData', params)
    },
}


// WEBPACK FOOTER //
// ./src/api/api_journalData.js